import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import PdfViewer from "../../components/controls/pdfviewer";

function Firms() {
  const navigate = useNavigate();
  const location = useLocation();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [tab, setTab] = useState("pending");
  const [firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [count, setCount] = useState(0);
  const [states, setStates] = useState([]);
  const [open, setOpen] = useState(false);
  const [approve, setApprove] = useState(false);
  const [firm, setFirm] = useState({ id: 0, isPublic: true });
  const [err, setErr] = useState("");
  const [isApproval, setIsApproval] = useState(null);
  const [option, setOption] = useState({});
  const role = location.pathname == "/admin-firms" ? "admin" : "user";

  const [lga, setLga] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (pageIndex >= 0) {
      onLoad();
    } else {
      setPageIndex(0);
    }

    if (states.length == 0) {
      onGetStates();
    }
  }, [pageIndex, pageSize, tab]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/firms/${tab}/${pageIndex}/${pageSize}`,
        {
          //
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setFirms(data.firms);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onClear = (item, index) => {
    console.log(tab);
  };
  const onEdit = (item, index) => {
    console.log(tab);
    setFirm(item);
    setOpen(true);
  };

  const onApprove = (item, index) => {
    console.log(tab);
    setFirm(item);
    setApprove(true);
  };
  const onFirmChange = (e) => {
    setFirm({ ...firm, [e.target.name]: e.target.value });
  };
  const onSave = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/profile/firm`, {
        method: "POST",
        body: JSON.stringify(firm),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpen(false);

        setAlert({
          open: true,
          title: "Law firm",
          subtitle: "Saved successfully",
        });
        setPageIndex(-1); // this will auto load again
        setFirm({ id: 0 }); //reset the value
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onSaveApprove = async (e) => {
    e.preventDefault();

    if (isApproval == null) {
      setErr("Please select the Approval Option");
      return;
    }
    var op = { id: firm.id, status: isApproval, reason: option.reason };
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/profile/approve-firm`, {
        method: "POST",
        body: JSON.stringify(op),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setApprove(false);
        setAlert({
          open: true,
          title: "Law firm",
          subtitle: `Law firm ${
            isApproval ? "Approved" : "Reject"
          } successfully`,
        });
        setPageIndex(-1); // this will auto load again
        setFirm({ id: 0 }); //reset the value
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (firm.stateId) {
      onGetLgs(firm.stateId);
    }
  }, [firm.stateId]);

  useEffect(() => {
    if (firm.localGovtAreaId) {
      onGetCities(firm.localGovtAreaId);
    }
  }, [firm.localGovtAreaId]);

  const onGetLgs = async (stateid) => {
    //for account registration
    try {
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLga(data);
    } catch (error) {
      console.error(error);
    }
  };
  const onGetCities = async (lgid) => {
    //for account registration
    try {
      //setLocs({...locs,city:false});

      const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setCities(data);
    } catch (error) {
      console.error(error);
    }
  };
  const onGetStates = async () => {
    //for account registration
    try {
      const resp = await fetch(`${Constants.apiUrl}/profile/states`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setStates(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Firms"
            isRoleBased={false}
            onClick={() => setTab("pending")}
          />
          <JisTabButton
            isActive={tab == "approved"}
            title="Approved Firms"
            isRoleBased={false}
            onClick={() => setTab("approved")}
          />
          <JisTabButton
            isActive={tab == "rejected"}
            title="Rejected Firms"
            isRoleBased={false}
            onClick={() => setTab("rejected")}
          />
        </div>

        <div className="tab_view">
          <div
            style={{
              textAlign: "right",
              marginBottom: "27px",
              marginTop: "27px",
            }}
          >
            <JisButton onClick={() => setOpen(true)}>Add Firm</JisButton>
          </div>
          {firms?.length == 0 && <JisEmptyList />}
          {firms?.length > 0 && (
            <div className="table">
              <div class="section-cases">
                <span>Firms</span>
                {/* <span className="total">{count}</span> */}
              </div>
              <div className="table-wrapper">
                <table className="case-table">
                  <thead>
                    <tr>
                      <th className="col-id">S/N</th>
                      <th className="col-title">Name</th>
                      <th>Desciption</th>
                      <th>Phone</th>
                      <th className="col-title">Email</th>
                      <th>State</th>
                      <th className="col-medium">Modifed On</th>
                      <th>Active</th>
                      <th>Public</th>
                      <th className="col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firms?.map((opt, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{opt.name || "N/A"}</td>
                        <td>{opt.description || "N/A"}</td>
                        <td>{opt.phone || "N/A"}</td>
                        <td>{opt.email || "N/A"}</td>
                        <td>
                          {Constants.getItemById(states, opt.stateId)?.title ||
                            "N/A"}
                        </td>

                        <td>
                          {" "}
                          {Constants.momentDate(opt.modifiedOn).format(
                            "DD MMM, YYYY"
                          ) || "N/A"}
                        </td>
                        <td>{opt.isActive == true ? "Yes" : "No"}</td>
                        <td>{opt.isPublic == true ? "Yes" : "No"}</td>

                        {tab == "pending" && (
                          <td>
                            <JisButton onClick={() => onEdit(opt, index)}>
                              Edit
                            </JisButton>
                            <JisButton onClick={() => onApprove(opt, index)}>
                              Approve
                            </JisButton>
                          </td>
                        )}
                        {tab == "approved" && (
                          <td>
                            <JisButton onClick={() => onClear(opt, index)}>
                              Clear
                            </JisButton>
                          </td>
                        )}
                        {tab == "rejected" && (
                          <td>
                            <JisButton onClick={() => onClear(opt, index)}>
                              Clear
                            </JisButton>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <BackLoader open={loading} />
      {open && (
        <JisDialogForm title="Firm" onClose={() => setOpen(false)}>
          <form onSubmit={onSave}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 3 }}>
                <div>
                  <div className="input-group">
                    <label>
                      Firm Name <span className="required">*</span>{" "}
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="group" />
                      <input
                        placeholder="Firm name"
                        required={true}
                        name="name"
                        type="text"
                        value={firm.name}
                        onChange={onFirmChange}
                      />
                    </div>
                  </div>
                  <div className="input-group">
                    <label>
                      Description <span className="required">*</span>{" "}
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="group" />
                      <input
                        placeholder="firm details"
                        required={true}
                        name="description"
                        type="text"
                        value={firm.description}
                        onChange={onFirmChange}
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label>
                        Phone Number <span className="required">*</span>{" "}
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="group" />
                        <input
                          placeholder="Phone"
                          required={true}
                          name="phone"
                          type="tel"
                          value={firm.phone}
                          onChange={onFirmChange}
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        Email <span className="required">*</span>{" "}
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="group" />
                        <input
                          placeholder="email"
                          required={true}
                          name="email"
                          type="email"
                          value={firm.email}
                          onChange={onFirmChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-group">
                    <label>
                      Address <span className="required">*</span>{" "}
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="group" />
                      <input
                        placeholder="firm address"
                        required={true}
                        name="address"
                        type="text"
                        value={firm.address}
                        onChange={onFirmChange}
                      />
                    </div>
                  </div>

                  <div style={{ display: "flex" }}>
                    <div className="select-group">
                      <label>
                        {" "}
                        State <span className="required">*</span>
                      </label>
                      <select
                        name="stateId"
                        required={true}
                        value={firm.stateId}
                        onChange={onFirmChange}
                      >
                        {<option value="">Select state</option>}
                        {states?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="select-group">
                      <label>
                        {" "}
                        L.G.A <span className="required">*</span>
                      </label>
                      <select
                        name="localGovtAreaId"
                        value={firm.localGovtAreaId}
                        required={true}
                        onChange={onFirmChange}
                      >
                        {<option value="">Select LG</option>}
                        {lga?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="select-group">
                      <label>
                        {" "}
                        City <span className="required">*</span>
                      </label>
                      <select
                        name="cityId"
                        value={firm.cityId}
                        required={true}
                        onChange={onFirmChange}
                      >
                        {<option value="">Select city</option>}
                        {cities?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <JisCheckbox
                      label="Check this to make firm public"
                      value={firm.isPublic}
                      onChange={(e) => setFirm({ ...firm, isPublic: e })}
                    />
                    {firm.id > 0 && (
                      <JisCheckbox
                        label="Check this to make firm active"
                        value={firm.isActive}
                        onChange={(e) => setFirm({ ...firm, isActive: e })}
                      />
                    )}
                  </div>
                </div>
                {err != "" && <div className="error">{err}</div>}
                <JisButton type="submit">Save </JisButton>{" "}
                <JisButton type="button" onClick={() => setOpen(false)}>
                  Cancel{" "}
                </JisButton>
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}

      {approve && (
        <JisDialogForm title="Firm Approval" onClose={() => setApprove(false)}>
          <form onSubmit={onSaveApprove}>
            <JisYesNo
              label={`Firm: ${firm.name}`}
              value={isApproval}
              yes="Approve"
              no="Reject"
              onChange={(e) => setIsApproval(e)}
            />
            <div className="input-group">
              <label>
                Comment <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <textarea
                  placeholder=" Reason"
                  name="reason"
                  required={true}
                  value={option.reason}
                  onChange={onOptionChange}
                />
              </div>
            </div>
            <JisButton type="submit">Save </JisButton>
          </form>
        </JisDialogForm>
      )}
    </div>
  );
}
export default Firms;
